import { Paper } from '@mui/material';
import React from 'react';

class InfoBox extends React.Component {
  static defaultProps = {
    title: 'Info',
    text: 'This is the text',
    rotated: '', //possible values: "", "+", "-"
  };

  render() {
    let rotated = '';
    if (this.props.rotated === '+') rotated = 'rotatedplus';
    if (this.props.rotated === '-') rotated = 'rotatedminus';

    return (
      <div className='col text-center m-1 d-flex align-items-center justify-content-center'>
        <Paper
          elevation={6}
          className={'p-1 stickynote infobox ' + rotated}
        >
          {this.props.title ? (
            <p>
              <b>{this.props.title}</b>
            </p>
          ) : null}
          <div className='text-left'>{this.props.text}</div>
        </Paper>
      </div>
    );
  }
}

export default InfoBox;
